import { render, staticRenderFns } from "./AvatarUpload.vue?vue&type=template&id=5ed31c48&"
import script from "./AvatarUpload.vue?vue&type=script&lang=js&"
export * from "./AvatarUpload.vue?vue&type=script&lang=js&"
import style0 from "./AvatarUpload.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports